'use client';

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useRouter, usePathname } from 'next/navigation';
import Globus from '@/app/components/svg/globus';
import SwitcherArrow from '@/app/components/svg/switcher-arrow';

const languages = [
  { code: 'default', label: 'SW' },
  { code: 'en', label: 'EN' },
];

export default function LanguageSwitcherEn() {
  const router = useRouter();
  const pathname = usePathname();
  const [selectedLang, setSelectedLang] = useState(languages[1]);
  const [isOpen, setIsOpen] = useState(false);

  // Определяем текущий язык при загрузке
  useEffect(() => {
    const segments = pathname.split('/').filter(Boolean);
    const currentLang = segments[0] === 'en' ? languages[1] : languages[0];
    setSelectedLang(currentLang);
  }, [pathname]);

  const handleSelect = (langCode: string) => {
    const currentSegments = pathname.split('/').filter(Boolean);
    const currentLang = currentSegments[0] === 'en' ? 'en' : 'default';
    
    // Если выбран уже активный язык, просто закрываем меню
    if ((langCode === 'default' && currentLang !== 'en') || 
        (langCode === 'en' && currentLang === 'en')) {
      setIsOpen(false);
      return;
    }

    setIsOpen(false);
    
    // Отправляем событие с информацией о текущем и новом языке
    window.dispatchEvent(new CustomEvent('languageChangeStart', {
      detail: {
        currentLang,
        newLang: langCode
      }
    }));

    let newSegments = [...currentSegments];
    
    if (langCode === 'default') {
      if (newSegments[0] === 'en') {
        newSegments.shift();
      }
    } else {
      if (newSegments[0] !== 'en') {
        newSegments.unshift('en');
      }
    }

    router.push('/' + newSegments.join('/'));
  };

  return (
    <div
      className="relative inline-block text-left"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="cursor-pointer py-[5px] transition flex items-center gap-[3.5px] text-[16px] font-bold text-violet-500">
        <Globus />
        {selectedLang.label}
        <SwitcherArrow />
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -5 }}
          className="absolute left-0 top-[22px] mt-2 w-full bg-white rounded-2xl shadow-xl shadow-[0_2px_8px_0_#00000026] z-10 min-w-[75px] px-[8px]"
        >
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`py-[5px] cursor-pointer text-[16px] font-semibold text-violet-500 border-b-2 last:border-b-0 border-dotted ${
                lang.code === selectedLang.code ? 'font-bold' : ''
              }`}
              onClick={() => {
                setSelectedLang(lang);
                handleSelect(lang.code);
              }}
            >
              {lang.label}
            </div>
          ))}
        </motion.div>
      )}
    </div>
  );
}